import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgLinkWeb24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69214 5.53424C9.06708 5.71303 9.41972 5.95623 9.73022 6.26666C11.1946 7.73107 11.1945 10.1059 9.73022 11.5704L6.90112 14.3985C5.43666 15.8629 3.06285 15.863 1.59839 14.3985C0.134231 12.934 0.134044 10.5601 1.59839 9.09576L4.28979 6.4024C4.20843 7.05684 4.26209 7.72537 4.45288 8.36139L2.65894 10.1563C1.78038 11.0349 1.78056 12.4593 2.65894 13.338C3.53761 14.2166 4.96189 14.2166 5.84058 13.338L8.66968 10.5098C9.54804 9.63128 9.54786 8.20684 8.66968 7.32819C8.4091 7.06769 8.09933 6.88534 7.77124 6.77936C7.81345 6.53337 7.9291 6.29728 8.1189 6.10748L8.69214 5.53424ZM9.09839 1.60162C10.5629 0.137158 12.9376 0.137157 14.4021 1.60162C15.866 3.0661 15.8663 5.44007 14.4021 6.90436L11.7029 9.6026C11.7857 8.94719 11.733 8.27799 11.5427 7.64069L13.3416 5.84381C14.2199 4.96531 14.2196 3.54086 13.3416 2.66217C12.4629 1.78349 11.0376 1.78349 10.1589 2.66217L7.33081 5.4903C6.4523 6.36892 6.45237 7.79327 7.33081 8.67194C7.5896 8.93063 7.89684 9.11153 8.22241 9.21783C8.17987 9.46268 8.06572 9.69764 7.87671 9.88678L7.30054 10.462C6.92842 10.2835 6.57868 10.0408 6.27026 9.73248C4.80604 8.26803 4.80596 5.89415 6.27026 4.42975L9.09839 1.60162Z",
    fill: "currentcolor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkWeb24);

export { ForwardRef as ReactComponent };
//# sourceMappingURL=LinkWeb24.svg.js.map
